import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Container from "@/components/Container";
import { api } from "@/lib/api";
import { ADMIN } from "@/constants/testIds";
import { toast } from "sonner";

const KEY_STATUSES = ["new","reviewing","shortlisted","contact_agent","viewing_booked","offer_sent","negotiating","purchase_agreed","acquired","in_renovation","ready_for_resale","listed_for_resale","sold"];

export default function DealPipeline() {
  const [board, setBoard] = useState({});
  const load = () => api.get("/pipeline").then(r => setBoard(r.data || {}));
  useEffect(() => { load(); }, []);

  const move = async (id, status) => {
    await api.put(`/properties/${id}`, { deal_status: status });
    toast.success(`Moved → ${status.replace(/_/g," ")}`); load();
  };

  return (
    <Container className="py-8 md:py-12">
      <p className="overline">Deals</p>
      <h1 className="mt-2 text-4xl md:text-5xl font-serif text-ivory">Deal Pipeline</h1>
      <p className="text-ivory/50 mt-2 text-sm">Drag-free kanban — click "Move →" on each card.</p>

      <div className="mt-8 flex gap-4 overflow-x-auto pb-6 no-scrollbar">
        {KEY_STATUSES.map(s => (
          <div key={s} data-testid={ADMIN.pipelineColumn(s)} className="w-72 shrink-0 luxury-card p-4">
            <p className="overline">{s.replace(/_/g, " ")}</p>
            <p className="text-xs text-ivory/40 mt-1">{board[s]?.length || 0} properties</p>
            <div className="mt-4 space-y-2 max-h-[60vh] overflow-y-auto pr-1">
              {(board[s] || []).map(p => (
                <div key={p.id} className="bg-charcoal-950 border border-charcoal-600 p-3 text-xs">
                  <Link to={`/admin/properties/${p.id}`} className="text-ivory hover:text-gold block truncate">{p.title}</Link>
                  <p className="text-[0.65rem] text-ivory/40 mt-1">{p.city} · £{(p.asking_price||0).toLocaleString()}</p>
                  <select onChange={e => move(p.id, e.target.value)} value={s}
                    className="mt-2 w-full bg-charcoal-800 border border-charcoal-600 px-2 py-1 text-[0.65rem] text-ivory/70">
                    {KEY_STATUSES.map(k => <option key={k} value={k}>{k.replace(/_/g," ")}</option>)}
                  </select>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </Container>
  );
}
